module.exports = __webpack_public_path__ + "media/img/about/person/putra-705b1cb0fbb3d3a2d317364ad6935a3a.png";